
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partiugpdainglaterra",
      function () {
        return require("private-next-pages/partiugpdainglaterra.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partiugpdainglaterra"])
      });
    }
  